function bbTimeRangeStackedController($scope, $attrs, $rootScope, $q, TimeService, AlertService, FormDataStoreService,
                                      PurchaseService, LoadingService, TimeSlotPermutationService) {

    let loader;

    this.$onInit = function () {
        FormDataStoreService.init('TimeRangeListStacked', $scope, [
            'selected_slot',
            'original_start_date',
            'start_at_week_start'
        ]);

        loader = LoadingService.$loader($scope).notLoaded();

        $rootScope.connection_started.then(() => {
            initScopeVariables();
            initTimeRange();
            $scope.loadData();
        });
    };

    /***
     * @ngdoc method
     * @name initScopeVariables
     * @methodOf BB.bbTimeRangeStacked
     * @description
     * Initialises options, time_range_length, day_of_week and selected_day
     */
    const initScopeVariables = function () {
        $scope.available_times = 0;

        let selected_day;
        $scope.options = $scope.$eval($attrs.bbTimeRangeStacked) || {};
        $scope.options.ignore_min_advance_datetime = $scope.options.ignore_min_advance_datetime ? true : false;

        if (!$scope.time_range_length) {
            if ($attrs.bbTimeRangeLength != null) {
                $scope.time_range_length = $scope.$eval($attrs.bbTimeRangeLength);
            } else if ($scope.options && $scope.options.time_range_length) {
                $scope.time_range_length = $scope.options.time_range_length;
            } else {
                $scope.time_range_length = 7;
            }
        }

        if (($attrs.bbDayOfWeek != null) || ($scope.options && $scope.options.day_of_week)) {
            $scope.day_of_week = ($attrs.bbDayOfWeek != null) ? $scope.$eval($attrs.bbDayOfWeek) : $scope.options.day_of_week;
        }

        if (($attrs.bbSelectedDay != null) || ($scope.options && $scope.options.selected_day)) {
            selected_day = ($attrs.bbSelectedDay != null) ? moment($scope.$eval($attrs.bbSelectedDay)) : moment($scope.options.selected_day);
            if (moment.isMoment(selected_day)) {
                $scope.selected_day = selected_day;
            }
        }

        if ($scope.bb.moving_booking) {
            $scope.bb.stacked_items = $scope.bb.basket.items;
        }
    };

    /***
     * @ngdoc method
     * @name initTimeRange
     * @methodOf BB.bbTimeRangeStacked
     * @description
     * Sets the time range based on stacked items / selected date
     */
    const initTimeRange = function () {
        // initialise the time range
        // last selected day is set (i.e, a user has already selected a date)
        if (!$scope.start_date && $scope.last_selected_date) {
            if ($scope.original_start_date) {
                let diff = $scope.last_selected_date.diff($scope.original_start_date, 'days');
                diff = diff % $scope.time_range_length;
                diff = diff === 0 ? diff : diff + 1;
                const start_date = $scope.last_selected_date.clone().subtract(diff, 'days');
                setTimeRange($scope.last_selected_date, start_date);
            } else {
                setTimeRange($scope.last_selected_date);
            }
            // the current item already has a date
        } else if ($scope.bb.stacked_items[0].date) {
            setTimeRange($scope.bb.stacked_items[0].date.date);
            // selected day has been provided, use this to set the time
        } else if ($scope.selected_day) {
            $scope.original_start_date = $scope.original_start_date || moment($scope.selected_day);
            setTimeRange($scope.selected_day);
            // set the time range as today
        } else {
            $scope.start_at_week_start = true;
            setTimeRange(moment());
        }
    };

    /***
     * @ngdoc method
     * @name setTimeRange
     * @methodOf BB.bbTimeRangeStacked
     * @description
     * Set time range in according of selected_date
     *
     * @param {date} selected_date The selected date from multi time range list
     * @param {date} start_date The start date of range list
     */
    const setTimeRange = function (selected_date, start_date) {
        if (start_date) {
            $scope.start_date = start_date;
        } else if ($scope.day_of_week) {
            $scope.start_date = selected_date.clone().day($scope.day_of_week);
        } else if ($scope.start_at_week_start) {
            $scope.start_date = selected_date.clone().startOf('week');
        } else {
            $scope.start_date = selected_date.clone();
        }

        $scope.selected_day = selected_date;
        // convert selected day to JS date object for date picker, it needs
        // to be saved as a variable as functions cannot be passed into the
        // AngluarUI date picker
        $scope.selected_date = $scope.selected_day.toDate();

        isSubtractValid();

        isAddValid();
    };

    /***
     * @ngdoc method
     * @name add
     * @methodOf BB.bbTimeRangeStacked
     * @description
     * Add date
     *
     * @param {object} amount The selected amount
     * @param {array} type The start type
     */
    $scope.add = function (amount, type) {
        $scope.selected_day = moment($scope.selected_date);
        switch (type) {
            case 'days':
                setTimeRange($scope.selected_day.add(amount, 'days'));
                break;
            case 'weeks':
                $scope.start_date.add(amount, 'weeks');
                setTimeRange($scope.start_date);
                break;
        }
        return $scope.loadData();
    };

    /***
     * @ngdoc method
     * @name subtract
     * @methodOf BB.bbTimeRangeStacked
     * @description
     * Subtract in according of amount and type parameters
     *
     * @param {object} amount The selected amount
     * @param {object} type The start type
     */
    $scope.subtract = (amount, type) => $scope.add(-amount, type);

    /***
     * @ngdoc method
     * @name isSubtractValid
     * @methodOf BB.bbTimeRangeStacked
     * @description
     * Verify if the subtract is valid or not
     */
    const isSubtractValid = function () {
        $scope.is_subtract_valid = true;

        const diff = Math.ceil($scope.selected_day.diff(moment(), 'day', true));
        $scope.subtract_length = diff < $scope.time_range_length ? diff : $scope.time_range_length;
        if (diff <= 0) {
            $scope.is_subtract_valid = false;
        }

        if ($scope.subtract_length > 1) {
            return $scope.subtract_string = `Prev ${$scope.subtract_length} days`;
        } else if ($scope.subtract_length === 1) {
            return $scope.subtract_string = 'Prev day';
        } else {
            return $scope.subtract_string = 'Prev';
        }
    };

    /***
     * @ngdoc method
     * @name isAddValid
     * @methodOf BB.bbTimeRangeStacked
     * @description
     * Use to determine if addition of the time range is valid (i.e. it's not more than the max days in advance)
     *
     */
    const isAddValid = function () {
        $scope.is_add_valid = true;

        if (!$scope.isAdmin() && !$scope.options.ignore_max_advance_datetime && $scope.max_date) {
            const max_date = $scope.max_date.clone();
            const selected_day = $scope.selected_day.clone();
            const difference = max_date.startOf('day').diff(selected_day.startOf('day'), 'days', true);
            if (difference - $scope.time_range_length < 0) {
                return $scope.is_add_valid = false;
            }
        }
    };

    /***
     * @ngdoc method
     * @name selectedDateChanged
     * @methodOf BB.bbTimeRangeStacked
     * @description
     * Called on datepicker date change
     */
    // called on datepicker date change
    $scope.selectedDateChanged = function () {
        setTimeRange(moment($scope.selected_date));
        $scope.selected_slot = null;
        return $scope.loadData();
    };

    /***
     * @ngdoc method
     * @name updateHideStatus
     * @methodOf BB.bbTimeRangeStacked
     * @description
     * Update the hidden status
     */
    const updateHideStatus = () =>
            (() => {
                const result = [];
                for (const key in $scope.days) {
                    const day = $scope.days[key];
                    result.push($scope.days[key].hide = !day.date.isSame($scope.selected_day, 'day'));
                }
                return result;
            })()
        ;


    /***
     * @ngdoc method
     * @name isPast
     * @methodOf BB.bbTimeRangeStacked
     * @description
     * Calculate if the current earliest date is in the past - in which case we. Might want to disable going backwards
     */
    // calculate if the current earliest date is in the past - in which case we
    // might want to disable going backwards
    $scope.isPast = function () {
        if (!$scope.start_date) {
            return true;
        }
        return moment().isAfter($scope.start_date);
    };

    /***
     * @ngdoc method
     * @name status
     * @methodOf BB.bbTimeRangeStacked
     * @description
     * Check the status of the slot to see if it has been selected
     *
     * @param {date} day The day
     * @param {object} slot The slot of day in multi time range list
     */
    // check the status of the slot to see if it has been selected
    // NOTE: This is very costly to call from a view, please consider using ng-class
    // to access the status
    $scope.status = function (day, slot) {
        if (!slot) {
            return;
        }

        const status = slot.status();
        return status;
    };

    /***
     * @ngdoc method
     * @name highlightSlot
     * @methodOf BB.bbTimeRangeStacked
     * @description
     * Check the highlight slot
     *
     * @param {date} day The day
     * @param {object} slot The slot of day in multi time range list
     */
    $scope.highlightSlot = function (slot, day) {
        if (day && slot && (slot.availability() > 0)) {
            $scope.bb.clearStackedItemsDateTime();
            if ($scope.selected_slot) {
                $scope.selected_slot.selected = false;
            }
            $scope.setLastSelectedDate(day.date);
            $scope.selected_slot = angular.copy(slot);
            $scope.selected_day = day.date;
            $scope.selected_date = day.date.toDate();

            // broadcast message to the accordion range groups
            $rootScope.$broadcast('slotChanged', day, slot);

            // set the date and time on the stacked items
            for (let i = 0; i < $scope.bb.stacked_items.length; i++) {

                const item = $scope.bb.stacked_items.find((item) => {
                    return (item.service.self === slot.service.self) && !item.date && !item.time;
                });

                item.setDate(day);
                item.setTime(slot);
                slot = slot.next;
            }

            updateHideStatus();
            return $rootScope.$broadcast('time:selected');
        }
    };

    /***
     * @ngdoc method
     * @name loadData
     * @methodOf BB.bbTimeRangeStacked
     * @description
     * Load the time data
     */
    // load the time data
    $scope.loadData = function () {

        loader.notLoaded();

        $scope.start_date = moment($scope.start_date);
        const edate = moment($scope.start_date).add($scope.time_range_length, 'days');
        $scope.end_date = moment(edate).add(-1, 'days');

        let selectedItems = $scope.bb.stacked_items;
        if (!selectedItems || !selectedItems.length) {
            selectedItems = [$scope.bb.current_item];
        }

        const people_promise = $scope.bb.company.$getPeople();

        const time_data_promise = TimeService.queryItems({
          company: $scope.bb.company,
          items: selectedItems,
          client: $scope.client,
          start_date: $scope.start_date,
          end_date: $scope.end_date
        });

        return $q.all([people_promise, time_data_promise]).then((res) => {
            const people = res[0];
            const timeData = res[1];

            $scope.days = TimeSlotPermutationService.findValidSlots(selectedItems, timeData);

            $scope.$broadcast('bbTimeRangeStacked-loadData:finished', $scope.days, people);
            $scope.setLoaded($scope);
        }, (err) => {
            $scope.setLoadedAndShowError($scope, err, 'Sorry, something went wrong');
        });
    };
    /***
     * @ngdoc method
     * @name pretty_month_title
     * @methodOf BB.bbTimeRangeStacked
     * @description
     * Display pretty month title in according of month format and year format parameters
     *
     * @param {date} month_format The month format
     * @param {date} year_format The year format
     * @param {string} separator The separator is '-'
     */
    $scope.pretty_month_title = function (month_format, year_format, seperator) {
        let start_date;
        if (seperator == null) {
            seperator = '-';
        }
        if (!$scope.start_date) {
            return;
        }
        const month_year_format = month_format + ' ' + year_format;
        if ($scope.start_date && $scope.end_date && $scope.end_date.isAfter($scope.start_date, 'month')) {
            start_date = $scope.start_date.format(month_format);
            if ($scope.start_date.month() === 11) {
                start_date = $scope.start_date.format(month_year_format);
            }
            return start_date + ' ' + seperator + ' ' + $scope.end_date.format(month_year_format);
        } else {
            return $scope.start_date.format(month_year_format);
        }
    };

    /***
     * @ngdoc method
     * @name confirm
     * @methodOf BB.bbTimeRangeStacked
     * @description
     * Confirm the time range stacked
     *
     * @param {string =} route A specific route to load
     * @param {object} options The options
     */
    $scope.confirm = function (route, options) {
        // first check all of the stacked items
        let booking;
        if (options == null) {
            options = {};
        }
        for (const item of Array.from($scope.bb.stacked_items)) {
            if (!item.time) {
                AlertService.add('danger', {msg: 'Select a time to continue your booking'});
                return false;
            }
        }

        if (($scope.bb.moving_booking != null) && ($scope.bb.moving_booking.bookings != null)) {
            let different = false;
            for (booking of Array.from($scope.bb.moving_booking.bookings)) {
                let found = false;
                for (const item of Array.from($scope.bb.stacked_items)) {
                    if ((booking.getDateString() === item.date.string_date) && (booking.getTimeInMins() === item.time.time) && (booking.category_name === item.category_name)) {
                        found = true;
                    }
                }
                if (!found) {
                    different = true;
                    break;
                }
            }
            if (!different) {
                AlertService.add('danger', {msg: 'Your treatments are already booked for this time.'});
                return false;
            }
        }

        // empty the current basket quickly
        $scope.bb.basket.clear();

        // add all the stacked items
        $scope.bb.pushStackToBasket();

        if ($scope.bb.moving_booking) {
            // if we're moving - confirm everything in the basket right now
            loader.notLoaded();

            // force purchase object re-loading on purchase page
            // see bbPurchase directive ($scope.init functions)
            $scope.bb.total = $scope.bb.total || {};
            $scope.bb.total.long_id = $scope.bb.purchase.long_id;

            const prom = PurchaseService.update({purchase: $scope.bb.purchase, bookings: $scope.bb.basket.items});

            prom.then((purchase) => {
                    purchase.$getBookings().then(bookings =>
                        (() => {
                            const result = [];
                            for (booking of Array.from(bookings)) {
                                // update bookings
                                let item1;
                                if ($scope.bookings) {
                                    item1 = (() => {
                                        const result1 = [];
                                        for (let _i = 0; _i < $scope.bookings.length; _i++) {
                                            const oldb = $scope.bookings[_i];
                                            let item2;
                                            if (oldb.id === booking.id) {
                                                item2 = $scope.bookings[_i] = booking;
                                            }
                                            result1.push(item2);
                                        }
                                        return result1;
                                    })();
                                }
                                result.push(item1);
                            }
                            return result;
                        })()
                    );
                    loader.setLoaded();
                    $scope.bb.current_item.move_done = true;
                    return $scope.decideNextPage();
                }
                , (err) => {
                    loader.setLoaded();
                    return AlertService.add('danger', {msg: 'Failed to move booking'});
                });
            return;
        }

        loader.notLoaded();

        if (options.do_not_route) {
            return $scope.updateBasket();
        } else {
            return $scope.updateBasket().then(() => {
                    loader.setLoaded();
                    return $scope.decideNextPage(route);
                }
                , err => loader.setLoadedAndShowError(err, 'Sorry, something went wrong'));
        }
    };

    /***
     * @ngdoc method
     * @name setReady
     * @methodOf BB.bbTimeRangeStacked
     * @description
     * Set this page section as ready
     */
    $scope.setReady = () => $scope.confirm('', {do_not_route: false});
}

angular.module('BBPublicBooking').controller('bbTimeRangeStackedController', bbTimeRangeStackedController);



// WEBPACK FOOTER //
// ../node_modules/bookingbug-angular/src/public-booking/time-range-stacked/bb_time_range_stacked.controller.js